import api from "../lib/api";

export const createReason = (payload: any) =>
  api.post("/api/reason/create-reason", payload);

export const deleteReason = (id: string) =>
  api.post(`/api/reason/delete-reason/${id}`);

export const updateStreamingStatus = (payload: any) =>
  api.post("/api/reason/update-streaming-status", payload);

export const updateRecordingStatus = (payload: any) =>
  api.post("/api/reason/update-recording-status", payload);

export const endProceeding = (payload: any) =>
  api.post("/api/reason/end-proceeding", payload);

export const getStopReasons = () => api.get("/api/reason/get-reason");
